import { render, staticRenderFns } from "./DataSetList.vue?vue&type=template&id=1a0c8c34"
import script from "./DataSetList.vue?vue&type=script&lang=js"
export * from "./DataSetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a0c8c34')) {
      api.createRecord('1a0c8c34', component.options)
    } else {
      api.reload('1a0c8c34', component.options)
    }
    module.hot.accept("./DataSetList.vue?vue&type=template&id=1a0c8c34", function () {
      api.rerender('1a0c8c34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/database/datamodel/DataSetList.vue"
export default component.exports